import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type RoleSpecsFragment } from '../../../api/fragments/RoleSpecs';
import DrawerWithAutoWidth from '../../../components/DrawerWithAutoWidth';
import RoleUpdateForm from './RoleUpdateForm';

export type RoleUpdateDrawerProps = {
    role: RoleSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const RoleUpdateDrawer = ({ role, onClose, visible }: RoleUpdateDrawerProps) => {
    const { t } = useTranslation(['roleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('roleDetails:updateDrawer.cancelButton')}</Button>
                    <Button form="updateRole" htmlType="submit" type="primary">
                        {t('roleDetails:updateDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('roleDetails:updateDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <RoleUpdateForm onComplete={onClose} role={role} />
        </DrawerWithAutoWidth>
    );
};

export default RoleUpdateDrawer;

export const useUpdateDrawer = (role: RoleUpdateDrawerProps['role']) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <RoleUpdateDrawer onClose={actions.close} role={role} visible={visible} />,
    };
};
